import { useUrlesDeEvidencia } from '@/modules/campo/useEvidencia'

import estilos from './FotosDelSobrante.module.css'

/**
 * Las fotos que mandó el técnico del material que sobró (0312). Quien
 * verifica las mira antes de contar: es lo que el técnico dice que devolvió.
 * Se abren en grande en otra pestaña.
 */
export function FotosDelSobrante({ rutas }: { rutas: string[] }) {
  const { urles, cargando } = useUrlesDeEvidencia(rutas)
  if (rutas.length === 0) {
    return <p className={estilos.sinFoto}>Sin foto del sobrante.</p>
  }

  return (
    <div className={estilos.fotos} aria-label="Fotos del material que sobró">
      {cargando
        ? rutas.map((r) => <span key={r} className={estilos.hueco} />)
        : urles.map((u, i) => (
            <a key={u} href={u} target="_blank" rel="noreferrer" className={estilos.foto}>
              <img src={u} alt={`Material que sobró, foto ${i + 1}`} loading="lazy" />
            </a>
          ))}
    </div>
  )
}
